import { customFetch } from "@/modules/fetch"
import type { Reaction } from "@/types"

export async function fetchFeedback(reaction: NonNullable<Reaction>, sessionId: string, messageId: string, feedback: string = "") {
  await customFetch(`/${sessionId}/rate-answer/${messageId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      reaction: reaction.toUpperCase(),
      feedback,
    }),
  })
}
